import config from '@/config/prod.env';
import { header } from '@/helper/header';
import { common } from '@/helper/common';

export const nguoiDungService = {
    queryData
};

async function queryData(params){
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithToken(),
        body: JSON.stringify(params)
    };
    return await fetch(`${config.LOGIN_URL}/NguoiDung/QueryData`, requestOptions).then(response => common.handleResponse(response));
}